import { render, staticRenderFns } from "./detailComponent.vue?vue&type=template&id=1e743371&"
import script from "./detailComponent.vue?vue&type=script&lang=js&"
export * from "./detailComponent.vue?vue&type=script&lang=js&"
import style0 from "./detailComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports